import { render, staticRenderFns } from "./VisitorsBadge.vue?vue&type=template&id=640e905e&"
import script from "./VisitorsBadge.vue?vue&type=script&lang=js&"
export * from "./VisitorsBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports